/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ImageCard from 'DesignSystem/ImageCard/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageViewGrid/ImageGrid/ImageSlot/PatientImage/Content",
  onImageAnalyze
  
}) {
let gridLayoutValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'layout',
})
let imageSlotDefinitionValueData = fromData.useDataValue({ viewPath,
context: 'image_slot',
path: 'definition',
})
let imageSlotItemIndexReverseValueData = fromData.useDataValue({ viewPath,
context: 'image_slot_item',
path: 'indexReverse',
})
let gridImagesLengthValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'images.length',
})
let gridImageSeriesIdValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'image_series_id',
})
let imageSlotPatientImageValueData = fromData.useDataValue({ viewPath,
context: 'image_slot',
path: 'patient_image',
})
let resourceObjectMetaValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
})
  return (<React.Fragment
>
<ImageCard
  viewPath={`${viewPath}/ImageCard`}
 data="grid.layout"
 layout={gridLayoutValueData}
 data="image_slot.definition"
 imageDefinition={imageSlotDefinitionValueData}
 data="image_slot_item.indexReverse"
 itemIndexReverse={imageSlotItemIndexReverseValueData}
 data="grid.images.length"
 imagesLength={gridImagesLengthValueData}
 data="grid.image_series_id"
 imageSeriesId={gridImageSeriesIdValueData}
 data="image_slot.patient_image"
 patientImage={imageSlotPatientImageValueData}
 data="resource_object_meta"
 resource={resourceObjectMetaValueData}
 onImageAnalyze={onImageAnalyze}
/>
{children}
</React.Fragment>)
}